import { useMemo } from 'react';
import { useTreeStore } from '../store/TreeStore';
import { useProcedureInstanceStore } from '../store/ProcedureInstanceStore';
import { PROCEDURETYPE } from '@/backend/models/procedureInstances/procedureInstanceBase';
import { Status } from '@/types/containerTypes';
import { useGetPreviousStep } from './useGetPreviousStep';

export const useStepHasDisabledStatus = (stepId: string): boolean => {
  const containerLookup = useTreeStore((state) => state.containerLookup);
  const procedure = useProcedureInstanceStore((state) => state.procedureInstance);
  const step = containerLookup[stepId];
  const stepForPosition = step?.container.isRepeatingStepChild() ? containerLookup[step.parentId] : step;
  const previousStep = useGetPreviousStep(stepForPosition?.stepPosition);

  const disabled = useMemo(() => {
    if (!step || !step.container || !stepForPosition) {
      return true;
    }

    const procedureStepOutOfOrder = procedure?.procedureType !== PROCEDURETYPE.TEMPLATE && (!stepForPosition.stepStartOverridden && previousStep?.container.status === Status.PENDING);

    return !!procedure?.signature
    || step.container.status !== Status.PENDING
    || procedureStepOutOfOrder;
  }, [procedure, step, previousStep, stepForPosition]);

  return disabled;
};
